(function () {
  var ROOT_SELECTOR = '[data-td-funda-builder]';

  var FALLBACK_COLORS = {
    'gris oscuro': {
      name: 'Gris oscuro',
      image: 'https://cdn.shopify.com/s/files/1/0698/1687/7356/files/gris_oscuro_6.webp?v=1781862189',
      swatch: '#57595a',
      kicker: 'Neutro profundo',
      description: 'Sobrio y equilibrado. Añade profundidad sin endurecer el ambiente y combina fácilmente con madera, negro y fibras naturales.',
      tags: ['Profundo', 'Fácil de combinar']
    },

    'gris claro': {
      name: 'Gris claro',
      image: 'https://cdn.shopify.com/s/files/1/0698/1687/7356/files/gris_claro_3_c6001581-d70d-4ff2-84c6-e96878b070f0.webp?v=1781862189',
      swatch: '#b7b7b4',
      kicker: 'Neutro luminoso',
      description: 'Luminoso y versátil. Suaviza visualmente el sofá y se integra fácilmente en espacios neutros, contemporáneos o cálidos.',
      tags: ['Luminoso', 'Máxima versatilidad']
    },

    'caqui': {
      name: 'Caqui',
      image: 'https://cdn.shopify.com/s/files/1/0698/1687/7356/files/cafe_1.webp?v=1781862189',
      swatch: '#887461',
      kicker: 'Cálido y orgánico',
      description: 'Un tono terroso y acogedor. Se integra especialmente bien con madera, lino, plantas y otras tonalidades naturales.',
      tags: ['Cálido', 'Tonos tierra']
    },

    'crema': {
      name: 'Crema',
      image: 'https://cdn.shopify.com/s/files/1/0698/1687/7356/files/beige_2_55ece28b-2ccd-41e2-837a-ce00bac69007.webp?v=1781862190',
      swatch: '#ddd5c7',
      kicker: 'Claro y sereno',
      description: 'Ilumina el sofá sin el contraste del blanco puro. Aporta una sensación suave, tranquila y naturalmente cálida.',
      tags: ['Cálido claro', 'Luz suave']
    },

    'cafe oscuro': {
      name: 'Café oscuro',
      image: 'https://cdn.shopify.com/s/files/1/0698/1687/7356/files/cafe_oscuro_1.webp?v=1781862189',
      swatch: '#543522',
      kicker: 'Cálido y profundo',
      description: 'Envolvente y elegante. Da presencia al sofá y crea una base sofisticada para madera, beige, crema y fibras naturales.',
      tags: ['Profundo', 'Maderas y fibras']
    },

    'negro': {
      name: 'Negro',
      image: 'https://cdn.shopify.com/s/files/1/0698/1687/7356/files/funda_full-negro_1.webp?v=1781862189',
      swatch: '#171717',
      kicker: 'Contraste definido',
      description: 'Gráfico y contemporáneo. Aporta estructura visual y crea un contraste editorial especialmente elegante en ambientes claros.',
      tags: ['Alto contraste', 'Contemporáneo']
    },

    'blanco': {
      name: 'Blanco',
      image: 'https://cdn.shopify.com/s/files/1/0698/1687/7356/files/WhatsApp_Image_2025-11-15_at_12.50.35_AM_c96539e2-7c87-4b38-b1ee-8065e8a7cbc9.jpg?v=1781862189',
      swatch: '#f4f3ef',
      kicker: 'Limpio y luminoso',
      description: 'Abre visualmente el espacio y realza la textura de la funda. Ideal para una estética fresca, ligera y depurada.',
      tags: ['Máxima luminosidad', 'Look limpio']
    }
  };

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');
  }

  function unique(values) {
    var seen = {};

    return values.filter(function (value) {
      var key = normalize(value);

      if (!key || seen[key]) return false;

      seen[key] = true;
      return true;
    });
  }

  function getGuideOption(colorName) {
    var wanted = normalize(colorName);

    return Array.from(
      document.querySelectorAll(
        '[data-td-color-guide] [data-td-color-option]'
      )
    ).find(function (option) {
      return normalize(option.dataset.name) === wanted;
    });
  }

  function getColorRecord(colorName) {
    var key = normalize(colorName);
    var guideOption = getGuideOption(colorName);
    var fallback = FALLBACK_COLORS[key] || {};

    if (!guideOption) {
      return {
        name: colorName || fallback.name || '',
        image: fallback.image || '',
        swatch: fallback.swatch || '#ded8ce',
        kicker: fallback.kicker || '',
        description: fallback.description || '',
        tags: fallback.tags || []
      };
    }

    var guideSwatch = guideOption.style
      .getPropertyValue('--td-guide-swatch')
      .trim();

    return {
      name: guideOption.dataset.name || colorName,
      image: guideOption.dataset.image || fallback.image || '',
      swatch: guideSwatch || fallback.swatch || '#ded8ce',
      kicker: guideOption.dataset.kicker || fallback.kicker || '',
      description:
        guideOption.dataset.description ||
        fallback.description ||
        '',
      tags: String(
        guideOption.dataset.tags || ''
      )
        .split('|')
        .map(function (tag) {
          return tag.trim();
        })
        .filter(Boolean)
    };
  }

  function initBuilder(root) {
    if (
      !root ||
      root.dataset.tdFundaColorDialogMounted === 'true'
    ) {
      return;
    }

    var trigger = root.querySelector(
      '[data-td-funda-color-dialog-open]'
    );

    var dialog = root.querySelector(
      '[data-td-funda-color-dialog]'
    );

    var closeButton = root.querySelector(
      '[data-td-funda-color-dialog-close]'
    );

    var palette = root.querySelector(
      '[data-td-funda-color-dialog-palette]'
    );

    var image = root.querySelector(
      '[data-td-funda-color-dialog-image]'
    );

    var caption = root.querySelector(
      '[data-td-funda-color-dialog-caption]'
    );

    var selectedDot = root.querySelector(
      '[data-td-funda-color-dialog-dot]'
    );

    var kicker = root.querySelector(
      '[data-td-funda-color-dialog-kicker]'
    );

    var selectedName = root.querySelector(
      '[data-td-funda-color-dialog-name]'
    );

    var description = root.querySelector(
      '[data-td-funda-color-dialog-description]'
    );

    var tags = root.querySelector(
      '[data-td-funda-color-dialog-tags]'
    );

    var applyButton = root.querySelector(
      '[data-td-funda-color-dialog-apply]'
    );

    var fullGuideButton = root.querySelector(
      '[data-td-funda-color-dialog-full]'
    );

    var status = root.querySelector(
      '[data-td-funda-color-dialog-status]'
    );

    if (
      !trigger ||
      !dialog ||
      !palette ||
      !image ||
      !applyButton
    ) {
      return;
    }

    root.dataset.tdFundaColorDialogMounted = 'true';

    var selectedColor = '';
    var records = [];
    var lastFocusedElement = null;
    var imageRequest = 0;

    function getBuilderColorButtons() {
      return Array.from(
        root.querySelectorAll(
          '[data-td-funda-base-color]'
        )
      );
    }

    function getAvailableColorNames() {
      return unique(
        getBuilderColorButtons().map(function (button) {
          return button.getAttribute(
            'data-td-funda-base-color'
          );
        })
      );
    }

    function getActiveBuilderColor() {
      var active = root.querySelector(
        '[data-td-funda-base-color][aria-pressed="true"],' +
        '[data-td-funda-base-color].is-active'
      );

      return active
        ? active.getAttribute('data-td-funda-base-color')
        : '';
    }

    function renderPalette() {
      records = getAvailableColorNames().map(
        getColorRecord
      );

      palette.replaceChildren();

      records.forEach(function (record) {
        var button = document.createElement('button');
        var dot = document.createElement('span');
        var name = document.createElement('span');
        var check = document.createElement('span');

        button.type = 'button';
        button.className =
          'td-funda-color-dialog__color';

        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', 'false');
        button.setAttribute(
          'data-td-funda-dialog-color',
          record.name
        );

        button.style.setProperty(
          '--td-dialog-color',
          record.swatch
        );

        dot.className =
          'td-funda-color-dialog__color-dot';

        dot.setAttribute('aria-hidden', 'true');

        name.className =
          'td-funda-color-dialog__color-name';

        name.textContent = record.name;

        check.className =
          'td-funda-color-dialog__color-check';

        check.setAttribute('aria-hidden', 'true');
        check.textContent = '✓';

        button.appendChild(dot);
        button.appendChild(name);
        button.appendChild(check);

        palette.appendChild(button);
      });
    }

    function findRecord(colorName) {
      var wanted = normalize(colorName);

      return records.find(function (record) {
        return normalize(record.name) === wanted;
      });
    }

    function updateImage(record, animate) {
      var requestId = ++imageRequest;

      if (!record || !record.image) {
        image.classList.remove('is-switching');
        return;
      }

      var nextSource = record.image;
      var nextAlt =
        'Funda Mágica TheDogs en color ' +
        record.name;

      if (
        image.getAttribute('src') === nextSource &&
        image.complete &&
        image.naturalWidth > 0
      ) {
        image.alt = nextAlt;
        image.classList.remove('is-switching');
        return;
      }

      function commitImage() {
        if (requestId !== imageRequest) return;

        image.alt = nextAlt;
        image.setAttribute('src', nextSource);

        window.requestAnimationFrame(function () {
          image.classList.remove('is-switching');
        });
      }

      if (animate !== false) {
        image.classList.add('is-switching');
      }

      var preload = new Image();
      preload.decoding = 'async';

      preload.onload = commitImage;
      preload.onerror = function () {
        if (requestId !== imageRequest) return;

        image.classList.remove('is-switching');

        if (status) {
          status.textContent =
            'No se pudo cargar la vista del color ' +
            record.name +
            '. Intenta nuevamente.';
        }
      };
      preload.src = nextSource;
    }

    function renderTags(record) {
      if (!tags) return;

      tags.replaceChildren();

      record.tags.forEach(function (tag) {
        var element = document.createElement('span');
        element.textContent = tag;
        tags.appendChild(element);
      });
    }

    function selectPreview(colorName, animate) {
      var record =
        findRecord(colorName) ||
        records[0];

      if (!record) return;

      selectedColor = record.name;

      Array.from(
        palette.querySelectorAll(
          '[data-td-funda-dialog-color]'
        )
      ).forEach(function (button) {
        var active =
          normalize(
            button.getAttribute(
              'data-td-funda-dialog-color'
            )
          ) === normalize(record.name);

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-checked',
          active ? 'true' : 'false'
        );

        button.tabIndex = active ? 0 : -1;
      });

      if (caption) {
        caption.textContent = record.name;
      }

      if (selectedDot) {
        selectedDot.style.background =
          record.swatch;
      }

      if (kicker) {
        kicker.textContent = record.kicker;
      }

      if (selectedName) {
        selectedName.textContent = record.name;
      }

      if (description) {
        description.textContent =
          record.description;
      }

      applyButton.textContent =
        'Elegir ' + record.name;

      renderTags(record);
      updateImage(record, animate !== false);

      if (status) {
        status.textContent =
          'Mostrando color ' + record.name;
      }
    }

    function openDialog() {
      renderPalette();

      var initialColor =
        getActiveBuilderColor() ||
        'Gris claro';

      selectPreview(initialColor, false);

      lastFocusedElement =
        document.activeElement;

      document.body.classList.add(
        'td-funda-color-dialog-open'
      );

      if (
        typeof dialog.showModal === 'function'
      ) {
        if (!dialog.open) {
          dialog.showModal();
        }
      } else {
        dialog.setAttribute('open', '');
      }

      window.setTimeout(function () {
        if (closeButton) {
          closeButton.focus();
        }
      }, 40);
    }

    function closeDialog(restoreFocus) {
      document.body.classList.remove(
        'td-funda-color-dialog-open'
      );

      if (
        typeof dialog.close === 'function' &&
        dialog.open
      ) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }

      if (
        restoreFocus !== false &&
        lastFocusedElement &&
        typeof lastFocusedElement.focus === 'function'
      ) {
        window.setTimeout(function () {
          lastFocusedElement.focus();
        }, 30);
      }
    }

    function applySelectedColor() {
      var target = getBuilderColorButtons().find(
        function (button) {
          return normalize(
            button.getAttribute(
              'data-td-funda-base-color'
            )
          ) === normalize(selectedColor);
        }
      );

      if (target) {
        target.click();
      }

      closeDialog(true);
    }

    function goToFullGuide() {
      var guide = document.querySelector(
        '[data-td-color-guide]'
      );

      if (!guide) return;

      var guideOption = Array.from(
        guide.querySelectorAll(
          '[data-td-color-option]'
        )
      ).find(function (option) {
        return normalize(option.dataset.name) ===
          normalize(selectedColor);
      });

      if (guideOption) {
        guideOption.click();
      }

      closeDialog(false);

      window.setTimeout(function () {
        var header =
          document.querySelector(
            '.shopify-section-header-sticky'
          ) ||
          document.querySelector(
            'sticky-header'
          ) ||
          document.querySelector(
            'header.header'
          );

        var offset = header
          ? Math.min(
              Math.round(
                header.getBoundingClientRect()
                  .height + 16
              ),
              140
            )
          : 84;

        var destination = Math.max(
          guide.getBoundingClientRect().top +
            window.pageYOffset -
            offset,
          0
        );

        window.scrollTo({
          top: destination,
          behavior: window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches
            ? 'auto'
            : 'smooth'
        });
      }, 90);
    }

    trigger.addEventListener(
      'click',
      openDialog
    );

    if (closeButton) {
      closeButton.addEventListener(
        'click',
        function () {
          closeDialog(true);
        }
      );
    }

    palette.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest(
          '[data-td-funda-dialog-color]'
        );

        if (!button) return;

        selectPreview(
          button.getAttribute(
            'data-td-funda-dialog-color'
          ),
          true
        );
      }
    );

    palette.addEventListener(
      'keydown',
      function (event) {
        var validKey =
          event.key === 'ArrowRight' ||
          event.key === 'ArrowDown' ||
          event.key === 'ArrowLeft' ||
          event.key === 'ArrowUp';

        if (!validKey) return;

        event.preventDefault();

        var buttons = Array.from(
          palette.querySelectorAll(
            '[data-td-funda-dialog-color]'
          )
        );

        var activeIndex = buttons.findIndex(
          function (button) {
            return (
              button.getAttribute(
                'aria-checked'
              ) === 'true'
            );
          }
        );

        var direction =
          event.key === 'ArrowRight' ||
          event.key === 'ArrowDown'
            ? 1
            : -1;

        var nextIndex =
          (Math.max(activeIndex, 0) +
            direction +
            buttons.length) %
          buttons.length;

        var nextButton =
          buttons[nextIndex];

        selectPreview(
          nextButton.getAttribute(
            'data-td-funda-dialog-color'
          ),
          true
        );

        nextButton.focus();
      }
    );

    applyButton.addEventListener(
      'click',
      applySelectedColor
    );

    if (fullGuideButton) {
      fullGuideButton.hidden =
        !document.querySelector(
          '[data-td-color-guide]'
        );

      fullGuideButton.addEventListener(
        'click',
        goToFullGuide
      );
    }

    dialog.addEventListener(
      'click',
      function (event) {
        if (event.target === dialog) {
          closeDialog(true);
        }
      }
    );

    dialog.addEventListener(
      'cancel',
      function (event) {
        event.preventDefault();
        closeDialog(true);
      }
    );

    dialog.addEventListener(
      'close',
      function () {
        document.body.classList.remove(
          'td-funda-color-dialog-open'
        );
      }
    );
  }

  function initAll() {
    document
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(initBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAll,
      { once: true }
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    function () {
      window.setTimeout(initAll, 0);
    }
  );
})();